import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { StoreService } from '../store.service';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { Message, SelectItem,ConfirmationService } from 'primeng/primeng';


@Component({
	selector: 'app-my-profile',
	templateUrl: './my-profile.component.html',
	providers: [ApiService,ConfirmationService],
	encapsulation: ViewEncapsulation.None
})

export class MyProfileComponent implements OnInit {
	loadingMessage: string = "loading...";
	userform: FormGroup;
	rahmaster: any;
	overrideTerms:boolean =false
	isJob: boolean = false;
	isClass: boolean = false;
	isItemDetail: boolean = false;
	isAccountDetail: boolean = true;
	AsyncBackEndScanning:boolean=false;
	DirectPostfromEmail:boolean=false;
	PurchaseOrderAsMemo:boolean=false;
	AsyncWithCustomer:boolean=false;
	creditDefaultAccount: any;
	msgs: Message[] = [];
	sausage: boolean;
	creditAccountList: SelectItem[] = [];

	constructor(private router: Router, private api: ApiService,
		private spinner: NgxSpinnerService,private confirmationService: ConfirmationService, private ss: StoreService,
		private fb: FormBuilder) { }

	ngOnInit() {

		
		this.getCreditAccount();
		this.userform = this.fb.group({
			'UserName': new FormControl(''),
			'Email': new FormControl(''),
			'Phone': new FormControl(''),
		});
		this.getMyAccount();
		this.getRah();
	}

	getMyAccount() {

		this.spinner.show();
		this.loadingMessage = "Please wait..."

		this.api.get('Account/Get', '').subscribe(
			(res: {}) => this.sucessGetMyAccount(res),
			error => this.failedGetMyAccount(<any>error));
	}

	sucessGetMyAccount(res: any) {
		this.userform = this.fb.group({
			UserName: [res.Data.UserName],
			Email: [res.Data.Email],
			Phone: [res.Data.Phone]
		});

		this.spinner.hide();
	}

	failedGetMyAccount(res: any) {
		this.spinner.hide();
	}

	onSubmit(value: string) {
		if (this.userform.valid) {
			this.spinner.show();
			this.api.post('Account/UpdatePhoneByAccountID?phone=' + this.userform.value.Phone+'&Email='+this.userform.value.Email, "").subscribe(
				(res: {}) => this.sucess(res),
				error => this.faild(<any>error));
		}
	}

	sucess(resp: any) {
		this.spinner.hide();
	}

	faild(resp: any) {
		this.spinner.hide();
	}

	getRah() {
		this.api.get('Rah/GetByAccountID', '').subscribe(
			(res: {}) => this.sucessQboMaster(res),
			error => this.failedQboMaster(<any>error));
	}

	getCreditAccount() {
		this.api.get('Rah/GetCreditAccountByAccountID', '').subscribe(
			(res: {}) => this.sucessQboCreditAccount(res),
			error => this.failedQboMaster(<any>error));
	}

	sucessQboCreditAccount(res: any) {
		if (res.StatusCode == 0) {
			console.log("acount Resp", res.Data);
			this.creditAccountList.push({ label: '', value: '' });
			res.Data.forEach(element => {
				this.creditAccountList.push({ label: element.FullName, value: element.ListID });
			  });
		}
	}

	onChangeItem(event: any) {
		this.creditDefaultAccount = event.value;
	  }

	failedQboMaster(res: any) {

	}

	sucessQboMaster(res: any) {
		if (res.StatusCode == 0) {
			this.rahmaster = res.Data[0];
			this.isJob = this.rahmaster.IsJob;
			this.isClass = this.rahmaster.IsClass;
			this.creditDefaultAccount = this.rahmaster.CreditDefaultAccount; //this.creditAccountList.filter(xx => xx.value == this.rahmaster.CreditDefaultAccount); 
			if (this.rahmaster.IsAccountDetail == null && this.rahmaster.IsItemDetail == null) {
				this.rahmaster.IsAccountDetail = true;
			}
			this.isAccountDetail = this.rahmaster.IsAccountDetail;
			this.isItemDetail = this.rahmaster.IsItemDetail;
			this.AsyncBackEndScanning=this.rahmaster.AsyncBackEndScanning;
			this.DirectPostfromEmail=this.rahmaster.DirectPostfromEmail;
			this.PurchaseOrderAsMemo = this.rahmaster.PurchaseOrderAsMemo;
			this.AsyncWithCustomer = this.rahmaster.AsyncWithCustomer
			this.overrideTerms = this.rahmaster.OverrideTerms;
			this.ss.storeSyncCustomer(this.AsyncWithCustomer)
			//this.appComponent.OverrideTerms = this.IsOverrideTerms = this.rahmaster.OverrideTerms;
		}
	}

	saveChecked() {
		
		this.rahmaster.OverrideTerms = this.overrideTerms;
		this.rahmaster.IsJob = this.isJob
		this.rahmaster.IsClass = this.isClass
		this.rahmaster.IsAccountDetail = this.isAccountDetail
		this.rahmaster.IsItemDetail = this.isItemDetail
		this.rahmaster.CreditDefaultAccount = this.creditDefaultAccount
		this.rahmaster.AsyncBackEndScanning=this.AsyncBackEndScanning;
		this.rahmaster.DirectPostfromEmail=this.DirectPostfromEmail;
		this.rahmaster.purchaseOrderAsMemo = this.PurchaseOrderAsMemo;
		this.rahmaster.asyncWithCustomer = this.AsyncWithCustomer;
		console.log(this.rahmaster);
		this.api.post('Account/UpdateClassJob', this.rahmaster).subscribe(
			(res: {}) => this.sucessUpdateIsCustomer(res),
			error => this.failedIsCustomerUpdate(<any>error));
	}

	sucessUpdateIsCustomer(res: any) {
		this.ss.storeSyncCustomer(this.AsyncWithCustomer)
		this.msgs = [];
		this.msgs.push({ severity: 'Info', summary: 'Updated Successfully.', detail: 'Success.' });

	}

	failedIsCustomerUpdate(failed: any) {

	}

	checkedChange(detail){
		this.isItemDetail = (detail == "Item")
		this.isAccountDetail = (detail == "Account")
		

	}
	directPostChange(event: any){
		console.log("change");
		if(event.target.checked==true){
		console.log("change");

			this.confirmationService.confirm({
				message: 'Are you sure want to direct post your invoices to reckon account without approval?',
				accept: () => {
					this.DirectPostfromEmail=true;
				  //this.spinner.show();
				  //this.loadingMessage = "Please wait..";
				 
				},
				reject: () => {
					this.DirectPostfromEmail=false;
				  //this.qboAccountIDSelected = 0;
				}
			  });
		}
	}

	ExitorEsc() {
		var pagename = 	this.ss.fetchPageName();
		console.log('pagename  ' + pagename);
		this.router.navigateByUrl(pagename);
	  }
}